import { type OnboardStep } from '@pkg/types/app/onboarding.ts';
import {
    FTU_EMPTY_ID,
    FTU_EMPTY_LINKS,
    FTU_FIRST_YAT_ID,
    FTU_SHARE_YAT_ID,
    FTU_USERNAME_ID,
    FTU_YAT_PICKER_ID,
} from '@pkg/types/constants/onboarding.ts';

const walletStep = {
    id: 'Onboard-Ftu-Step-5',
    // This is only rendered within the `NFTSection > EmptyState`,
    // and therefor will not be available for users who have
    // already connected a wallet and added NFTs.
    target: FTU_EMPTY_ID,
    route: 'nfts',
    title: 'Finally, add your NFTs',
    message: 'Connect your wallet to see and manage your NFTs.',
};
const shareStep = {
    id: 'Onboard-Ftu-Step-6',
    target: FTU_SHARE_YAT_ID,
    title: 'Share your Yat',
    message: 'Share your vanity URL as your link-in-bio on your X, Insta, Discord and more.',
};

export const baseSteps: OnboardStep[] = [
    {
        id: 'Onboard-Ftu-Step-1',
        target: FTU_FIRST_YAT_ID,
        route: 'yats',
        title: 'Here’s your new Yat!',
    },
    {
        id: 'Onboard-Ftu-Step-2',
        target: FTU_YAT_PICKER_ID,
        title: 'Pick your default Yat',
        message: 'Pick the Yat that you want to display on your Yat Profile.',
    },
    {
        id: 'Onboard-Ftu-Step-3',
        target: FTU_USERNAME_ID,
        title: 'Set a username',
        message: 'Make your profile stand out with a unique username. You can change this any time.',
    },
    {
        id: 'Onboard-Ftu-Step-4',
        target: FTU_EMPTY_LINKS,
        route: 'links',
        title: 'Personalise your profile with links',
        message: 'Links allow you to share things you love with the world.',
    },
];

export const stepsSansWallet = [...baseSteps, shareStep];
export const stepsFtu = [...baseSteps, walletStep, shareStep];
